module.exports = __webpack_public_path__ + "img/img25.2dc7b09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img25.png
// module id = 202
// module chunks = 0